import request, { Methods, withToken } from "../../../../utils/request";
import { getUserCompany } from "../../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const GET_UBICATION_REQUEST = "GET_UBICATION_REQUEST";
export const GET_UBICATION_SUCCESS = "GET_UBICATION_SUCCESS";
export const GET_UBICATION_ERROR = "GET_UBICATION_ERROR";

//* ACTIONS ------------------------------------------------
export const getUbicationRequest = (payload = {}, callback) => ({
  type: GET_UBICATION_REQUEST,
  payload,
  callback,
});

export const getUbicationSuccess = (data) => ({
  type: GET_UBICATION_SUCCESS,
  payload: data,
});

export const getUbicationError = (error) => ({
  type: GET_UBICATION_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const getUbicationServiceRequest = async (ubicationId) => {
  const options = await withToken({
    method: Methods.GET,
    headers: { CompanyId: await getUserCompany() },
  });

  return request(`/ubications/${ubicationId}`, options);
};
